<template>
  <div class="header-nav">
    <ul>
      <li
        v-for="(item, i) in menu"
        :key="i"
        :class="[{'drop': item.items, 'active': activeMenu(item.label)}]"
        @click="toggleMenu(item)"
      >
        <span v-if="item.items">{{item.label}}</span>
        <span v-else>
          <router-link to="/Dashboard">{{item.label}}</router-link>
        </span>
        <ul v-if="item.items && item.collapsed">
          <li v-for="(item, j) in item.items" :key="j">
            <router-link v-if="item.link === '/eLearning'" :to="item.link">{{item.label}}</router-link>
            <a v-else :href="item.link" target="_blank">{{item.label}}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menu: [
        {
          label: "pulpit",
          collapsed: false
        },
        {
          label: "warunki handlu",
          collapsed: false,
          items: [
            { label: "instrumenty", link: "//www.mforex.pl/warunki-handlu" },
            { label: "punkty SWAP", link: "//www.mforex.pl/warunki-handlu" },
            { label: "zabezpieczenia", link: "//www.mforex.pl/warunki-handlu" },
            {
              label: "opłaty i prowizje",
              link: "//www.mforex.pl/warunki-handlu"
            },
            { label: "regulaminy", link: "//www.mforex.pl/regulaminy" }
          ]
        },
        {
          label: "narzędzia inwestora",
          collapsed: false,
          items: [
            // { label: 'mNews - serwis informacyjno - analityczny', icon: 'images/icons/icon-5.svg', link: '//www.mforex.pl/mnews/#/market' },
            {
              label: "mNews - serwis informacyjny",
              link: "//www.mforex.pl/mnews/#/market"
            },
            { label: "mForex Web", link: "//webtrader.mforex.pl/" },
            {
              label: "mForex Trader - MT4 - pobierz",
              link: "//www.mforex.pl/do-pobrania-pliki-instalacyjne"
            },
            {
              label: "instrukcje obsługi",
              link: "//www.mforex.pl/baza-wiedzy-mforex-trader"
            },
            { label: "klient doświadczony", link: "/eLearning" }
          ]
        }
      ]
    };
  },
  methods: {
    toggleMenu(element) {
      if (element.collapsed) {
        this.menu.forEach(item => {
          item.collapsed = false;
        });
      } else {
        this.menu.forEach(item => (item.collapsed = false));
        element.collapsed = true;
      }
    },
    activeMenu(link) {
      let active = false;
      switch (link) {
        case "pulpit":
          active = this.$route.meta.title === "Pulpit" ? true : false;
          break;
        case "narzędzia inwestora":
          active = this.$route.meta.title === "eLearning" ? true : false;
          break;
        default:
          active = false;
          break;
      }
      return active;
    }
  }
};
</script>